<template>
    <AuthLayout>
        <div
            class="flex w-full flex-col items-center bg-white px-6 pb-6 sm:max-w-[344px]"
        >
            <div class="flex justify-center">
                <img
                    :src="emailSent"
                    alt="Dmarceye profile password reset link sent"
                    title="Dmarceye profile password reset link sent"
                    :class="['block mx-auto mb-12', `w-458px]`, `h-276px]`]"
                />
            </div>

            <div
                class="mt-6 text-center text-3xl font-bold leading-9 text-[#161E2E]"
            >
                {{ $t("vue.check_your_inbox") }}
            </div>

            <div
                class="mt-6 max-w-[344px] text-center text-[12.25px] font-normal leading-[1.42] text-black"
            >
                {{ $t("vue.sent_password_reset_instructions") }}
            </div>

            <div class="mt-6 w-full">
                <inertia-link :href="route('login')" class="block w-full">
                    <MegaButton
                        class="w-full !rounded-md !bg-[#088BEA] !py-3 !text-sm !font-medium !text-white !shadow-none hover:!bg-[#067DD2] focus:!ring-0"
                    >
                        {{ $t("vue.sign_in_again") }}
                    </MegaButton>
                </inertia-link>
            </div>
        </div>
    </AuthLayout>
</template>

<script setup lang="ts">
import route from "ziggy-js";

const emailSent = new URL(
    "/resources/js/assets/images/email-sent.svg",
    import.meta.url,
).href;
</script>
